import { QueryApiService } from 'src/common/api-service';

export class PersonAccountCancellationApiService extends QueryApiService<PersonAccountCancellationApiService> {
  constructor() {
    super('personAccountCancellation');
    this._apiBaseUrl = `${window.REACT_APP_API_BASE_URI}/api/v1/personAccountCancellation`;
    this._odataBaseUrl = `${window.REACT_APP_API_BASE_URI}/odata/v1/personAccountCancellation`;
  }
}
